import { render, staticRenderFns } from "./sms-record.vue?vue&type=template&id=8b320646&scoped=true"
import script from "./sms-record.vue?vue&type=script&lang=js"
export * from "./sms-record.vue?vue&type=script&lang=js"
import style0 from "./sms-record.vue?vue&type=style&index=0&id=8b320646&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b320646",
  null
  
)

export default component.exports